import React from "react";
import { Controller } from "react-hook-form";
import { TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import moment from "moment";

/**
 * Reusable DatePicker component controlled by react-hook-form
 *
 * @param {string} name - Field name in the form
 * @param {string} label - Label for the date picker
 * @param {object} control - react-hook-form control object
 * @param {object} errors - react-hook-form errors object
 * @param {boolean} disableFuture - Optional: disable dates after today
 * @param {string} inputFormat - Optional: format of the date (default "MM/DD/YYYY")
 */
const DatePickerController = ({
  name,
  label,
  control,
  errors,
  disableFuture = false,
  inputFormat = "MM/DD/YYYY",
  disabled = false,
  highlight = false,
}) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <DatePicker
          label={label}
          value={field.value ? moment(field.value, inputFormat) : null}
          onChange={(date) => {
            const formattedDate = date ? moment(date).format(inputFormat) : "";
            field.onChange(formattedDate);
          }}
          inputFormat={inputFormat}
          maxDate={disableFuture ? moment() : undefined}
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              error={!!errors?.[name]}
              helperText={errors?.[name]?.message}
              sx={{
                ...(highlight && {
                  "& .MuiInputBase-input": {
                    color: "red",
                  },
                }),
              }}
            />
          )}
          disabled={disabled}
        />
      )}
    />
  );
};

export default DatePickerController;
